<app-generic-table
    [tableConfig]="tableConfig"
    [filtersConfig]="filtersConfig"
    (tableEvent)="retrieveAgencies($event)">
</app-generic-table>